import axios from 'axios';
// import _ from 'lodash';
// Project imports
// import * as types from './actionTypes';
import * as urls from './urlTypes';

import { toastError } from '../util/toastUtils';
import { RLD_SEAT_LIMIT_ERROR } from '../components/RldTool/RldConstant';

export const getSubscriptionDetails = async (accountId, id) => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/entitlement/${id}/${accountId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get subscriptons details');
    return false;
  }
};

export const saveSubscription = async (accountId, entitlement) => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/subscription`;
  let method = 'post';
  if (entitlement.id) {
    url = `${urls.API_GATEWAY_URL}/api/admin-service/entitlement/${entitlement.id}/${accountId}`;
    method = 'put';
  }
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
      data: entitlement,
    });
    return response;
  } catch (error) {
    if (error.response.data.status === 422) {
      return {
        error: error.response.data.message,
      };
    } else if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to save subscription');
    return false;
  }
};
